export default __webpack_public_path__ + "static/media/image-speaker-zx7.3d4940e8.jpg";